// extracted by mini-css-extract-plugin
export default {"title":"Stories_title__oyQkv","container":"Stories_container__8K-0-","stories":"Stories_stories__ZpIPm","story":"Stories_story__aBM2L"};